import { gql } from '@apollo/client';
import { EXPORT_INSTITUTION } from '../../fragments';

export const EXPORT_EDUCATOR_SCHOOLS = gql`
  query ExportEducatorSchools($input: ExportArgs!) {
    institutions: allEducatorSchools(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          ...exportInstitution
        }
      }
    }
  }
  ${EXPORT_INSTITUTION}
`;
